import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { content } from "../../../../constants/tariffTile";
import { Icon } from "../Icon";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var BadgeText = function BadgeText(_ref) {
  var isDark = _ref.isDark,
    forEsim = _ref.forEsim,
    availableOnlyInOffice = _ref.availableOnlyInOffice;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('badge-text'),
    "data-t-id": "components-BadgeText"
  }, forEsim && /*#__PURE__*/React.createElement("div", {
    className: cn('eSIM')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('eSIM__icon')
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cn({
      'sim--white': isDark
    }),
    name: "eSim"
  })), /*#__PURE__*/React.createElement(Text, {
    color: isDark ? 'white' : 'grey95',
    size: "size6-r",
    tagType: "span"
  }, content.eSim.text)), availableOnlyInOffice && /*#__PURE__*/React.createElement("div", {
    className: cn('available-only-in-office')
  }, /*#__PURE__*/React.createElement(Text, {
    color: isDark ? 'white' : 'grey95',
    size: "size6-r",
    tagType: "span"
  }, content.availableOnlyInOffice.text)));
};